import { render, staticRenderFns } from "./risk-definition-applied-control-form.vue?vue&type=template&id=11489444"
import script from "./risk-definition-applied-control-form.vue?vue&type=script&lang=js"
export * from "./risk-definition-applied-control-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports